import { createTransform } from 'redux-persist';

const SetTransform = createTransform(inboundState => {
  return { ...inboundState, loading: false, error: '' };
});

export default SetTransform;
